<div class="media ignore-elements" (click)="openAssignment()">
	<div class="media-body media-heading">
		<h3 class="media-title">
			<span class="media-details">
				<span class="media-title-item">
					{{asgmt.title}}
				</span>
				<rl-due-date class="due-dates-box" *ngIf="asgmt.dueDate" [date]="asgmt.dueDate"></rl-due-date>
			</span>
		</h3>
		<div>{{asgmt.description}}</div>
		<div class="citation-status">
			<div class="label label-warning">{{'asgmt.visibility.' + asgmt.status | translate}}</div>
		</div>
		<rl-assignment-menu class="media-actions" *ngIf="!editMode" [assignment]="asgmt" (onDelete)="onDelete.emit()"></rl-assignment-menu>
	</div>
</div>